module.exports = __webpack_public_path__ + "static/media/iconLibraryActive.d64e5346.svg";